import {
  AbsolutePositionAligner,
  MenuItem,
  useDocumentEvent,
} from '@sgcmpteltd/uikit-react';
import {
  DOCUMENT_EVENT_NAME_CLICK,
} from '@sgcmpteltd/uikit-react/hooks/use-document-event';
import {
  alignBottomXBegin,
} from '@sgcmpteltd/uikit-react/utils/position/absolute';
import cx from 'clsx';
import { useEffect, useRef, useState } from 'react';

import { categoryToText } from '@/hooks/use-filter-params/configs';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Select: Component = ({
  selectName,
  optionList,
  selectValues,
  setSelectValues,
  rectCalculator = alignBottomXBegin,
}) => {
  const select = selectValues[selectName];
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const buttonRootElRef = useRef<HTMLDivElement>(null);
  const menuRootElRef = useRef<HTMLDivElement>(null);
  const onDocMouseClickRef = useRef<Document['onclick'] | null>(null);

  const handleButtonClick = () => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
      return;
    }
    setIsDropdownOpen(true);
  };

  const handleItemClick = (value?: string | number | undefined) => {
    if (value !== undefined && value !== null) {
      setSelectValues({
        ...selectValues,
        [selectName]: {
          ...selectValues[selectName],
          optionValue: {
            text: categoryToText[value],
            value,
          },
        },
      });
    }
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (hasApplied) {
      setIsDropdownOpen(false);
      setHasApplied(false);
    }
  }, [hasApplied]);

  onDocMouseClickRef.current = ({ target }) => {
    if (
      (target instanceof Node
      && (buttonRootElRef.current?.contains(target)
      || menuRootElRef.current?.contains(target)
      ))
    ) {
      return;
    }
    setIsDropdownOpen(false);
  };
  useDocumentEvent({
    eventName: DOCUMENT_EVENT_NAME_CLICK,
    eventHandlerRef: onDocMouseClickRef,
  });
  const targetElement = (
    <div
      ref={menuRootElRef}
      className={styles.menuCheckRoot}>
      <div className={styles.containerMenuList}>
        {optionList.map(option => (
          <MenuItem
            key={option.value}
            isActive={option.value === select.optionValue.value}
            value={option.value}
            onClick={handleItemClick}>
            {option.text}
          </MenuItem>
        ))}
      </div>
    </div>
  );
  return (
    <AbsolutePositionAligner
      isActive={isDropdownOpen}
      rectCalculator={rectCalculator}
      targetElement={targetElement}>
      <div
        ref={buttonRootElRef}
        role="button"
        tabIndex={0}
        onClick={handleButtonClick}
        onKeyDown={handleButtonClick}>
        <div className={`${cx(styles.containerHead, isDropdownOpen && styles.isDropdownOpen)} ${
          select.optionValue.value
            ? styles.activeContainerHead
            : ''
        }`}>
          <div className={styles.textButton}>
            {select.optionValue.text || selectName}
          </div>
        </div>
      </div>
    </AbsolutePositionAligner>
  );
};
